import { Component, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { NgxGlideComponent } from 'ngx-glide';
import { HomeService } from '../../home.service';

@Component({
    selector: 'app-featured-champions',
    templateUrl: './featured-champions.component.html',
    styleUrls: ['./featured-champions.component.scss'],
})
export class FeaturedChampionsComponent implements OnInit {
    registers: any;
    /**
     * Instancia do ngx glide
     */
    @ViewChildren('ngxGlide') ngxGlide!: QueryList<NgxGlideComponent>;

    /**
     * Configuração do slide por breakpoint
     */
    breakpoints = {
        767: {
            perView: 1,
        },
    };

    constructor(private homeService: HomeService) {}

    ngOnInit(): void {
        this.homeService.getFeaturedChampions().subscribe((response) => {
            this.registers = response.registers;
        });
    }

    onTabChange($event) {
        console.log(`recreating`);
        setTimeout(() => {
            this.ngxGlide.forEach((ngxGlide) => ngxGlide.recreate());
        }, 0);
    }
}
